if (!customElements.get('product-card-toggle')) {
  class ProductCardToggle extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.handlePanelClick = this.handlePanelClick.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.scrollPosition = 0;
    }

    connectedCallback() {
      this.btn = this.querySelector('.product-card__mobile-toggle__btn');
      if (this.btn) this.btn.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      if (this.btn) this.btn.removeEventListener('click', this.handleClick);
      const card = this._activeCard;
      const quickAdd = card && card.querySelector('details[open]');
      if (quickAdd && document.querySelector('.product-card__quick-add-panel.is-detached')) {
        this.close(card, quickAdd);
      }
      this.removePanelListener();
    }

    handleClick() {
      const targetId = this.dataset.target;
      const card = this.closest('.product-card');
      const quickAdd = card && card.querySelector(`#${targetId}`);
      if (!quickAdd) return;

      const isOpen = quickAdd.hasAttribute('open');
      if (isOpen) {
        this.close(card, quickAdd);
      } else {
        this._activeCard = card;
        this.scrollPosition = window.scrollY;
        this.lockBody();
        document.documentElement.style.minHeight = `${document.documentElement.scrollHeight}px`;
        const panel = card.querySelector('.product-card__quick-add-panel');
        if (panel) {
          this.originalParent = panel.parentElement;
          this.originalNextSibling = panel.nextElementSibling;
          document.body.appendChild(panel);
          panel.classList.add('is-detached');
        }
        quickAdd.setAttribute('open', '');
        card.classList.add('is-quick-add-open');
        document.addEventListener('keydown', this.handleKeyDown);
        this.addPanelListener(card, quickAdd, panel);
      }
    }

    close(card, quickAdd) {
      this.unlockBody();
      document.removeEventListener('keydown', this.handleKeyDown);
      if (quickAdd) quickAdd.removeAttribute('open');
      if (card) card.classList.remove('is-quick-add-open');
      if (this.panel) {
        this.panel.classList.remove('is-detached');
        if (this.originalParent) {
          this.originalParent.insertBefore(this.panel, this.originalNextSibling || null);
        }
        this.originalParent = null;
        this.originalNextSibling = null;
        document.documentElement.style.minHeight = '';
      }
      this.removePanelListener();
    }

    lockBody() {
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.touchAction = 'none';
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    }

    unlockBody() {
      document.documentElement.style.overflow = '';
      document.documentElement.style.touchAction = '';
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }

    addPanelListener(card, quickAdd, panel) {
      this.panel = panel || card.querySelector('.product-card__quick-add-panel');
      this.activeCard = card;
      this.activeQuickAdd = quickAdd;
      if (this.panel) this.panel.addEventListener('click', this.handlePanelClick);
    }

    removePanelListener() {
      if (this.panel) {
        this.panel.removeEventListener('click', this.handlePanelClick);
        this.panel = null;
      }
      this.activeCard = null;
      this.activeQuickAdd = null;
    }

    handleKeyDown(event) {
      if (event.key === 'Escape') {
        const card = this._activeCard;
        const quickAdd = card && card.querySelector('details[open]');
        if (quickAdd) this.close(card, quickAdd);
      }
    }

    handlePanelClick(event) {
      if (event.target.classList.contains('product-card__quick-add-panel')) {
        this.close(this.activeCard, this.activeQuickAdd);
      }
    }
  }

  customElements.define('product-card-toggle', ProductCardToggle);
}
